import { createMuiTheme } from '@material-ui/core/styles'

export default createMuiTheme({
  palette: {
    primary: { main: '#065899' },
    secondary: { main: '#ee6931' },
  },
})
